import { BaseQuery } from "./_BaseQuery";

export class CompanyAnnotationQuery extends BaseQuery {
	public company_Id?:string;
	public accountNumber?:string;
	public company_SynchronizationKey?:string;
}
